import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { NAV_GROUP_ORDER } from '@/config/nav-config';

type SidebarGroupsState = {
  openGroups: Record<string, boolean>;
  toggleGroup: (groupKey: string) => void;
  isGroupOpen: (groupKey: string) => boolean;
};

const defaultOpenGroups = Object.fromEntries(
  NAV_GROUP_ORDER.map((key) => [key, true])
);

export const useSidebarGroups = create<SidebarGroupsState>()(
  persist(
    (set, get) => ({
      openGroups: defaultOpenGroups,
      toggleGroup: (groupKey) =>
        set((state) => ({
          openGroups: {
            ...state.openGroups,
            [groupKey]: !state.openGroups[groupKey]
          }
        })),
      isGroupOpen: (groupKey) => get().openGroups[groupKey] ?? true
    }),
    { name: 'sidebar-groups', skipHydration: true }
  )
);
